export const UNKNOWN_UPLOAD_VALUE = "Unknown";

const formatUploadDateTime = (uploadedAt?: string | null): string => {
  if (!uploadedAt?.trim()) {
    return UNKNOWN_UPLOAD_VALUE;
  }

  const date = new Date(uploadedAt);
  if (Number.isNaN(date.getTime())) {
    return uploadedAt;
  }

  return date.toLocaleString();
};

export const formatDocumentUploadInfo = (
  uploadedBy?: string | null,
  uploadedAt?: string | null
): { who: string; when: string; tooltip: string } => {
  const who = uploadedBy?.trim() || UNKNOWN_UPLOAD_VALUE;
  const when = formatUploadDateTime(uploadedAt);
  return {
    who,
    when,
    tooltip: `Uploaded by ${who}\n${when}`,
  };
};
